var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"slide-fade"}},[(_vm.isShowMessage)?_c('div',{staticClass:"a-flash-message",class:{'a-flash-message--alert': _vm.withAlert},on:{"click":_vm.onHide}},[_c('i',{staticClass:"crevo-icon crevo-close a-flash-message__close"}),_vm._t("default",function(){return [_vm._v(_vm._s(_vm.text))]})],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }